module.exports = __webpack_public_path__ + "img/ceyiceOne copy.f69bfc3b.png";